import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account Redux states
import { SIGNUP_ADMIN_USER } from "./actionTypes";
import { signupAdminUserSuccess, signupAdminUserError } from "./actions";

import { AppConfiguration } from "config";

import { postJwtRegister } from "helpers/sf_backend_helper";

// Is user register successfull then direct plot user in redux.
function* SignUpAdminUser({ payload: { user, history } }) {
  try {
    const response = yield call(
      postJwtRegister,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_signup`,
      user)
    yield put(signupAdminUserSuccess(response))

    history.push("/login?flash_message_type=success&flash_message_text=Registration successful, please login to proceed.")
  } catch (error) {
    yield put(signupAdminUserError(error))
  }
}

export function* watchSignUpAdminUser() {
  yield takeEvery(SIGNUP_ADMIN_USER, SignUpAdminUser)
}

function* SignUpAdminUserSaga() {
  yield all([fork(watchSignUpAdminUser)])
}

export default SignUpAdminUserSaga;
